import ImageIcon from "@mui/icons-material/Image";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideocamIcon from "@mui/icons-material/Videocam";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import PanoramaPhotosphereSelectIcon from "@mui/icons-material/PanoramaPhotosphereSelect";

export const getTypeIcon = (type: any) => {
  switch (type) {
    case "image":
      return <ImageIcon />;
    case "pdf":
      return <PictureAsPdfIcon />;
    case "video":
      return <VideocamIcon />;
    case "object":
      return <ViewInArIcon />;
    case "panorama":
      return <PanoramaPhotosphereSelectIcon />;
    default:
      return null;
  }
};
